import React, { createContext, useState, useContext, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { fetchUserDetails } from '../datafetch/fetchUserDetails';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null); // null = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
  
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const details = await fetchUserDetails(user.uid);
        setUserDetails(details);
      } else {
        setUserDetails({});
      }
      setLoading(false);
    });
  
    return () => unsubscribe();
  }, []);
  

  return (
    <UserContext.Provider value={{ userDetails, setUserDetails, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);




// import React, { createContext, useState, useContext } from 'react';

// const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [userDetails, setUserDetails] = useState({
//     streakCount: 0,
//     courseBookings: [],
//     totalTokens: 0,
//     lastPracticeLessonId: null,
//     subscriptionStatus: false,
//   });

//   return (
//     <UserContext.Provider value={{ userDetails, setUserDetails }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUser = () => useContext(UserContext);
